import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { NoteDTO } from '@iota/iota-management-portal-v4-client';
import moment from 'moment';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { user } from 'src/app/store/reducer/user.reducer';
import { Store } from '@ngrx/store';

export type NoteListItem = Pick<NoteDTO, 'noteId' | 'note' | 'creationBy' | 'creationById'> & { creationDateTime?: Date | string };

@Component({
    standalone: false,
    selector: 'app-note-list',
    templateUrl: './note-list.component.html',
    styleUrls: ['./note-list.component.scss']
})
export class NoteListComponent implements OnChanges {
    user$ = this.store.select(user);

    notesContainer = [] as NoteListItem[];
    newNote: NoteListItem = { note: '' };

    @Input() notes: NoteListItem[];
    @Input() disabled = false;

    @Output() add: EventEmitter<NoteListItem> = new EventEmitter();
    @Output() delete: EventEmitter<NoteListItem> = new EventEmitter();

    textEditor = ClassicEditor;

    // Toolbar grouping measures the container once on init, which is unreliable when the editor starts inside a dialog.
    editorConfig = { toolbar: { shouldNotGroupWhenFull: true } };

    constructor(private store: Store) {}

    ngOnChanges(changes: SimpleChanges) {
        const value = changes?.['notes']?.currentValue;
        if (value) {
            this.notesContainer = [...value];
            this.notesContainer.sort(
                (a, b) => moment(b.creationDateTime).toDate().getTime() - moment(a.creationDateTime).toDate().getTime()
            );
        }
    }

    addNote() {
        this.add.emit(this.newNote);
        this.newNote = { note: '' };
    }

    deleteNote(note: NoteListItem) {
        this.delete.emit(note);
    }
}
